import React, { useCallback } from 'react';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';

export const Select = props => {
	const { options, onChange, ...selectProps } = props;
	const handleChange = useCallback(
		(event: any, index: number, newValue: string) => {
			onChange && onChange(newValue);
		},
		[onChange],
	);
	return (
		<SelectField {...selectProps} onChange={handleChange}>
			{options.map(option => (
				<MenuItem key={option.id} value={option.value} primaryText={option.text || option.value} />
			))}
		</SelectField>
	);
};



// WEBPACK FOOTER //
// src/components/ui/select/select.jsx